import { useState, useEffect, useContext } from 'react';
import { UserContext, UserContextType } from 'src/contexts/UserContext';
import { useDisclosure } from '@chakra-ui/react';
import { InfoBlock } from 'src/components/info-block';
import SvgInfo from 'src/components/icons/info';
import { useRouter } from 'next/router';
import type { Reppl } from '../service';
import PostingOptionModal from '../../studio/side-widget/posting-option-modal';

interface CreateEpisodeProps {
  reppl: Reppl;
}

export function CreateEpisode({ reppl }: CreateEpisodeProps) {
  const router = useRouter();
  const { user, isLogin } = useContext(UserContext) as UserContextType;

  const [isViewer, setIsViewer] = useState(true);
  const [isShowButton, setIsShowButton] = useState(false);

  let defaultEpisodeTpye = router.query.episodeType
    ? router.query.episodeType.toString().toLocaleLowerCase()
    : 'official';
  if (defaultEpisodeTpye === 'official' && !reppl.isOfficial) {
    defaultEpisodeTpye = 'open';
  }
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [episodeType, setEpisodeType] = useState<string>(defaultEpisodeTpye);

  const episodes = {
    official: {
      dispalyName: 'Official',
      seq: 0,
      desc:
        'Official episodes are reviewed and curated by the editing team of this RE:PPL.',
      desc2: '',
      display: reppl.isOfficial,
      CTA: 'Submit an episode',
      sub: 'Submitted episodes will be only published when approved.',
      canSubmit: reppl.canSubmitOfficial,
    },
    open: {
      dispalyName: 'Open',
      seq: 1,
      desc: 'Unabridged creativity reigns supreme here in Open Episodes.',
      desc2: 'Submit a post related to this RE:PPL and be part of the making.',
      display: reppl.isOpen,
      CTA: 'Submit an episode',
      canSubmit: reppl.canSubmit,
    },
  };

  const openModalOrSignin = () => {
    if (isLogin) {
      onOpen();
    } else {
      router.push({ query: { ...router.query, page: 'signIn' } });
    }
  };

  const getEpisodeDesc = () => {
    if (episodes[episodeType].canSubmit || !isViewer) {
      return `${episodes[episodeType].desc} ${episodes[episodeType].desc2}`;
    }
    return episodes[episodeType].desc;
  };

  useEffect(() => {
    if (reppl && user) {
      let isView = true;
      reppl.team.forEach((teamUser) => {
        if (teamUser.userID === user.id) {
          isView = false;
        }
      });
      if (episodes[episodeType].canSubmit) {
        setIsShowButton(true);
      }
      if (!episodes[episodeType].canSubmit && !isView) {
        setIsShowButton(true);
      }
      if (!episodes[episodeType].canSubmit && isView) {
        setIsShowButton(false);
      }
      setIsViewer(isView);
    }
  }, [reppl, user, episodeType]);

  // const editingTeam = isStarter(reppl?.userRole) || isEditor(reppl?.userRole);
  // const isRoleEditor = isEditor(reppl?.userRole);
  // const isOwner = isStarter(reppl?.userRole);

  useEffect(() => {
    if (router.query.episodeType) {
      setEpisodeType(`${router.query.episodeType}`);
    }
  }, [router.query.episodeType]);
  return (
    <div className="border-beaver-100 overflow-hidden w-full border rounded">
      <div className="flex">
        <span
          className="text-black bg-white dark:text-white font-bold flex-1 text-center py-4 rounded-t cursor-pointer dark:bg-jaguar"
          aria-hidden="true"
        >
          {episodes[episodeType].dispalyName} Episodes
        </span>
      </div>

      <InfoBlock borderRadius="0" border="0" pt={0}>
        <p className="text-gray-500">{getEpisodeDesc()}</p>
        {isShowButton && (
          <>
            <button
              className="rounded-md w-full py-2 mt-4 text-white bg-blue-500 font-bold"
              type="button"
              onClick={openModalOrSignin}
            >
              {episodes[episodeType].CTA}
            </button>
            <p className="text-sm text-gray-500">{episodes[episodeType].sub}</p>
          </>
        )}
        <div className="hidden flex items-center mt-4">
          <SvgInfo className="text-teal-200 text-2xl mr-1" />
          <p className="text-gray-500">
            What is an {episodes[episodeType].dispalyName.toLowerCase()}{' '}
            episode?
          </p>
        </div>
      </InfoBlock>
      <PostingOptionModal
        episodeType={episodeType}
        reppl={reppl}
        modal={{ isOpen, onClose }}
      />
    </div>
  );
}
